

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
//import { PatientAppointment } from '../patient-services/patient-appointment';
//import { PatientRegistration } from '../patient-services/patient-registration';



export interface imageatch_detParameter extends Parameter {
  SearchTerm: number;
  OrderBy: string;

}

export interface imageatch_det {
  id?: any;
  tenantId: any;
  branchId: any;
  containerName: string;
  fileLocation: string;
  fileName: string;
  category: string;
  createdDate: Date;
  createdBy: string;
  phyId?:any,
  empId?:any,
  patId?:any,
  isView?:any,
  isCreate?:any;
  isEdit?:any;
  approvalId?:any;
  approvalDet?:any;
}


export abstract class imageatch_detData {

    abstract list(url: string): Observable<imageatch_det[]>;
  //   abstract getDashboardData(url: string): Observable<any>;
  //   abstract getDashboardList(url: string): Observable<any[]>;
  abstract getById(url: string): Observable<any>;
  abstract create(url: string, data: any): Observable<any>;
  abstract update(url: string, data: any): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
